import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ExpandableCard = ({ title, summary, children, icon, defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-surface rounded-lg border border-border overflow-hidden mb-4">
      <button
        onClick={toggleExpanded}
        className="w-full p-4 text-left hover:bg-muted transition-colors duration-150"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {icon && (
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name={icon} size={16} color="white" strokeWidth={2} />
              </div>
            )}
            <div>
              <h3 className="font-semibold text-text-primary">{title}</h3>
              {summary && (
                <p className="text-sm text-text-secondary mt-1">{summary}</p>
              )}
            </div>
          </div>
          <Icon 
            name="ChevronDown" 
            size={20} 
            color="currentColor"
            className={`transition-transform duration-150 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </div>
      </button>
      
      {isExpanded && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="pt-4">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpandableCard;